import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

const TrendingJobs = () => {
  const navigate = useNavigate();

  const jobCategories = [
    { job: "Accounting Jobs", name: "accounting" },
    { job: "Analytics Jobs", name: "analytics" },
    { job: "Animation Jobs", name: "animation" },
    { job: "Architecture Jobs", name: "architecture" },
    { job: "Banking Jobs", name: "banking" },
    { job: "BPO Jobs", name: "bpo" },
    { job: "Data Science Jobs", name: "data-science" },
    { job: "Java Jobs", name: "java" },
    { job: "Marketing Jobs", name: "marketing" },
    { job: "Design Jobs", name: "design" },
    { job: "UX/UI Jobs", name: "ux-ui" }
  ];

  return (
    <Container className="my-4">
      <div className="trending-skills-slider">
        <Row className="align-items-center g-0">
          
          {/* Left Title Header */}
          <Col xs={12} md={2} className="slider-header mb-2 mb-md-0">
            <h5 className="mb-0 fw-bold">Trending Jobs in India</h5>
          </Col>

          {/* Controls & Swiper Flexbox Track Wrapper */}
          <Col xs={12} md={10}>
            <Row className="align-items-center g-0 position-relative">
              
              {/* Previous Slider Navigation Button */}
              <Col xs="auto" className="text-start">
                <button className="custom-nav-btn custom-prev-btn" aria-label="Previous slide">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                  </svg>
                </button>
              </Col>

              {/* Responsive Swiper Container track */}
              <Col className="overflow-hidden px-2">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  navigation={{
                    prevEl: ".trending-skills-slider .custom-prev-btn",
                    nextEl: ".trending-skills-slider .custom-next-btn",
                  }}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  slidesPerView="auto"
                  spaceBetween={10}
                  freeMode={true}
                  className="skillsSwiper"
                >
                  {jobCategories.map((items, index) => (
                    <SwiperSlide key={index} style={{ width: "auto" }}>
                      <div
                        onClick={() => navigate(`/jobexp?id=${items?.name}`)}
                        className="skill-badge-btn"
                      >
                        {items.job}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>

              {/* Next Slider Navigation Button */}
              <Col xs="auto" className="text-end">
                <button className="custom-nav-btn custom-next-btn" aria-label="Next slide">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </button>
              </Col>

            </Row>
          </Col>

        </Row>
      </div>
    </Container>
  );
};

export default TrendingJobs;